import { readWml } from './utils/wmlUtils.js';
const getDocumentPages = async (state) => {
    const documentPages = {};
    const pages = state.pages.getAll();
    for (const { pageId, pagePath } of pages) {
        const page = state.fileStructure.getPageFilesPaths(pagePath);
        const data = await readWml(state.fileSystem, page.document);
        documentPages[pageId] = { data };
    }
    return documentPages;
};
export const getSiteDocument = async (state) => {
    const documentPages = await getDocumentPages(state);
    const { masterPage, ...otherPages } = documentPages;
    if (!masterPage) {
        throw new Error('Missing master page');
    }
    return {
        pages: {
            masterPage,
            ...otherPages
        }
    };
};
